// Mi lista de amigos en tiempo real (agregado 16/10/2026).
import { useEffect, useMemo, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase-config";

const useFriends = (myUid?: string | null) => {
  const [friendIds, setFriendIds] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!myUid) {
      setFriendIds([]);
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    const unsubscribe = onSnapshot(
      doc(db, "Amigos", myUid),
      (snap) => {
        const lista = snap.exists() ? snap.data().Lista : [];
        setFriendIds(Array.isArray(lista) ? lista : []);
        setIsLoading(false);
      },
      (error) => {
        console.error("Error escuchando amigos:", error);
        setIsLoading(false);
      },
    );
    return () => unsubscribe();
  }, [myUid]);

  const friendSet = useMemo(() => new Set(friendIds), [friendIds]);

  return { friendIds, friendSet, isLoading };
};

export default useFriends;
